import React from 'react'
import {components as selectComponents} from 'react-select'

import {FiltersOptionType} from './types'

export const MultiValueLabel: React.FC<{data: FiltersOptionType}> = props => {
  const data: FiltersOptionType = props.data
  let label: React.ReactNode = data.label
  let labelPrefix: string | undefined = undefined
  
  // Helper to check if value has required prefix ("+")
  const isRequired = (value: unknown): boolean =>
    typeof value === 'string' && value.startsWith('+')
  
  // Helper to get text search label with required prefix handling
  const getTextSearchLabel = (
    baseLabel: string,
    value: unknown,
  ): string => {
    return isRequired(value) ? `Required ${baseLabel}` : baseLabel
  }
  
  if (data.type === 'itemType') labelPrefix = 'Type'
  else if (data.type === 'rarity') labelPrefix = 'Rarity'
  else if (data.type === 'significance') labelPrefix = 'Subrarity'
  else if (data.type === 'text:nameAndMeta')
    labelPrefix = getTextSearchLabel('Name/Meta', data.value)
  else if (data.type === 'text:description')
    labelPrefix = getTextSearchLabel('Description', data.value)
  else if (data.type === 'text:flavour')
    labelPrefix = getTextSearchLabel('Flavor', data.value)
  else if (data.type === 'cardVolume') labelPrefix = 'Card Vol.'
  else if (data.type === 'bookVolume') labelPrefix = 'Book'
  else if (data.type === 'treasureTheme') labelPrefix = 'Theme'
  else if (data.type === 'tag')
    labelPrefix = isRequired(data.value) ? 'Required tag' : 'Tag'

  // TODO: determine why data.label doesn't use the labels from the Select choices array
  let valueLabel = data.label
  if (data.type === 'rarity' && data.value === '__multiple_rarities__')
    valueLabel = 'varies'

  if (labelPrefix) {
    label = (
      <>
        <small>
          <strong>{labelPrefix.toUpperCase()}</strong>
        </small>{' '}
        | {valueLabel}
      </>
    )
  }
  const newProps = {...props, children: label}
  return <selectComponents.MultiValueLabel {...newProps} />
}
